/** Storage units remain unchanged so old payments and reservations retain value. */
export const DISPLAY_CREDITS_PER_UNIT = 50;
export const AI_MONTHLY_PLAN = Object.freeze({
    key: "ai-monthly-v1", name: "Starter", priceCents: 1000,
    units: 2400, freeUnits: 800,
});
export const AI_MONTHLY_PLANS = [
    AI_MONTHLY_PLAN,
    Object.freeze({ key: "ai-monthly-plus-v1", name: "Plus", priceCents: 2500, units: 6000, freeUnits: 800 }),
    Object.freeze({ key: "ai-monthly-pro-v1", name: "Pro", priceCents: 5000, units: 12000, freeUnits: 800 }),
] as const;
export type AiMonthlyPlan = typeof AI_MONTHLY_PLANS[number];
export function getAiMonthlyPlan(key: unknown) { return AI_MONTHLY_PLANS.find(plan => plan.key === key) ?? null; }
export function displayCredits(units: number): number { return units * DISPLAY_CREDITS_PER_UNIT; }
export function formatCredits(units: number): string { return displayCredits(units).toLocaleString("en-US"); }
export function storageCredits(credits: number): number | null {
    return Number.isSafeInteger(credits) && credits > 0 && credits % DISPLAY_CREDITS_PER_UNIT === 0
        ? credits / DISPLAY_CREDITS_PER_UNIT : null;
}
export function freeCreditPeriod(now: Date) {
    return { key: now.toISOString().slice(0, 7), expiresAt: new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1)) };
}
export function monthlyCreditsEnabled(): boolean { return process.env.AI_MONTHLY_PLAN_ENABLED === "true"; }
